"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsHandler = exports.originalTarget = exports.removeProxy = exports.addProxy = exports.emitterMethods = void 0;
const denyList = ["disposed"];
exports.emitterMethods = new Map(Object.entries({
    addListener: "addListener",
    on: "addListener",
    prependListener: "prependListener",
    removeListener: "removeListener",
    off: "removeListener",
}));
exports.addProxy = Symbol("AddProxy");
exports.removeProxy = Symbol("RemoveProxy");
exports.originalTarget = Symbol("originalTarget");
function hasMaxListeners(obj) {
    return "setMaxListeners" in obj && "getMaxListeners" in obj;
}
class EventsHandler {
    constructor() {
        this.proxies = new WeakMap();
        this.proxyEvents = new WeakMap();
    }
    getOrCreateEvent(target) {
        let obj = this.proxyEvents.get(target);
        if (obj == null) {
            obj = [];
            this.proxyEvents.set(target, obj);
        }
        return obj;
    }
    addProxy(target, impl) {
        var _a, _b;
        if (hasMaxListeners(target) && hasMaxListeners(impl)) {
            const n = target.getMaxListeners();
            if (impl.getMaxListeners() < n) {
                impl.setMaxListeners(n);
            }
        }
        for (const proxyEvent of (_a = this.proxyEvents.get(target)) !== null && _a !== void 0 ? _a : []) {
            // remove all events from old implementations and add it to new one
            impl.addListener(proxyEvent.type, proxyEvent.listener);
        }
        impl.once("disposed", this.removeProxy.bind(this, target, impl));
        if (!this.proxies.has(target)) {
            this.proxies.set(target, new Set());
        }
        (_b = this.proxies.get(target)) === null || _b === void 0 ? void 0 : _b.add(impl);
    }
    removeProxy(target, impl) {
        var _a;
        for (const proxyEvent of (_a = this.proxyEvents.get(target)) !== null && _a !== void 0 ? _a : []) {
            // simply unsubscribe and remove form proxies
            impl.removeListener(proxyEvent.type, proxyEvent.listener);
        }
        const proxies = this.proxies.get(target);
        if (proxies != null) {
            proxies.delete(impl);
        }
    }
    addListener(target, type, listener) {
        var _a;
        const impls = (_a = this.proxies.get(target)) !== null && _a !== void 0 ? _a : [];
        const events = this.getOrCreateEvent(target);
        events.push({ type, listener });
        target.addListener(type, listener);
        if (!denyList.includes(type)) {
            for (const impl of impls) {
                impl.addListener(type, listener);
            }
        }
    }
    prependListener(target, type, listener) {
        var _a;
        const impls = (_a = this.proxies.get(target)) !== null && _a !== void 0 ? _a : [];
        const events = this.getOrCreateEvent(target);
        events.unshift({ type, listener });
        target.prependListener(type, listener);
        if (!denyList.includes(type)) {
            for (const impl of impls) {
                impl.prependListener(type, listener);
            }
        }
    }
    removeListener(target, type, listener) {
        var _a;
        const impls = (_a = this.proxies.get(target)) !== null && _a !== void 0 ? _a : [];
        const events = this.getOrCreateEvent(target);
        for (let i = 0; i < events.length; i++) {
            if (type === events[i].type && listener === events[i].listener) {
                events.splice(i, 1);
            }
        }
        target.removeListener(type, listener);
        if (!denyList.includes(type)) {
            for (const impl of impls) {
                impl.removeListener(type, listener);
            }
        }
    }
    get(target, key, receiver) {
        if (key === exports.originalTarget) {
            return target;
        }
        if (key === exports.addProxy) {
            return this.addProxy.bind(this, target);
        }
        if (key === exports.removeProxy) {
            return this.removeProxy.bind(this, target);
        }
        if (exports.emitterMethods.has(key)) {
            const method = exports.emitterMethods.get(key);
            if (method != null) {
                return this[method].bind(this, target);
            }
        }
        return Reflect.get(target, key, receiver);
    }
}
exports.EventsHandler = EventsHandler;
//# sourceMappingURL=events-handler.js.map